import Box from "@mui/material/Box";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import IconButton from "@mui/material/IconButton";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import arrowLeftIcon from "../../../assets/icon-left.svg";
import { useBrandThemeColors } from "../../../branding";

type TriageResultDetailBreadcrumbProps = Readonly<{
  objectTypeLabel: string;
  objectId: string;
  resultId: string;
  onBack: () => void;
  onObjectTypeClick: () => void;
}>;

export default function TriageResultDetailBreadcrumb({
  objectTypeLabel,
  objectId,
  resultId,
  onBack,
  onObjectTypeClick,
}: TriageResultDetailBreadcrumbProps) {
  const { primaryColor } = useBrandThemeColors();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        mb: 2,
      }}
    >
      <IconButton
        aria-label="Go back"
        onClick={onBack}
        sx={{ width: 32, height: 32, p: 1, flexShrink: 0 }}
      >
        <Box
          component="img"
          src={arrowLeftIcon}
          alt=""
          sx={{
            width: 16.25,
            height: 16,
            display: "block",
            objectFit: "contain",
          }}
        />
      </IconButton>
      <Breadcrumbs
        aria-label="Triage result breadcrumb"
        separator=">"
        sx={{
          "& .MuiBreadcrumbs-separator": {
            color: "#9ca3af",
            mx: 0.75,
          },
        }}
      >
        <Link
          component="button"
          variant="body1"
          onClick={onObjectTypeClick}
          sx={{
            color: primaryColor,
            textDecoration: "none",
            cursor: "pointer",
            fontSize: "0.875rem",
            fontWeight: 500,
            "&:hover": { textDecoration: "underline" },
          }}
        >
          {objectTypeLabel}
        </Link>
        <Typography sx={{ color: "#6b7280", fontSize: "0.875rem" }}>
          {objectId}
        </Typography>
        <Typography
          sx={{ color: "#374151", fontSize: "0.875rem", fontWeight: 500 }}
        >
          {resultId}
        </Typography>
      </Breadcrumbs>
    </Box>
  );
}
